import { TemplateConfig } from '../core/config.scorecard.model';
import { ScorecardGridOptions } from '../core/scorecard-grid-options.model';
import {
    ScorecardGridDirectType,
    WidgetType,
} from '../core/template-definition.model';

/** @deprecated should be called whenever ScorecardTab.selectedScorecard is assigned */
export function determineDirectReportGrids(
    templateConfig: TemplateConfig,
): ScorecardGridDirectType[] {
    let result: ScorecardGridDirectType[];
    try {
        const scorecardWidget = templateConfig.widgets.find(
            (w) => w.widgetType === WidgetType.SCORECARD_GRID,
        );
        result = (scorecardWidget.options as ScorecardGridOptions)
            .directReportGrids;
    } catch (err) {}
    return result;
}
